import _GroupSummary from './model';

const GroupSummary = _GroupSummary;

export default GroupSummary;



// WEBPACK FOOTER //
// ./containers/Group/GroupSummary/index.js